import { DefaultApi, ClosedOnboardingApi } from './api';
import { ONBOARDING_TOKEN } from '~constants/localStorageIndexes';

import {
  ApiResponse,
  CreateOnboardingResponse,
  OnboardingCreditInfoResponse,
  SaveProductPayload,
  SaveRepresentativesPayload,
  RepresentativeUpdatePayload,
  Onboarding,
  OnboardingToken,
} from './types';

import parseJWT from '~utils/parseJWT';

export const create = (payload: any) =>
  DefaultApi.request<CreateOnboardingResponse>(`/onboardings`, {
    method: 'POST',
    data: payload,
  });

export const getCreditInfo = (onboardId: string) =>
  DefaultApi.request<OnboardingCreditInfoResponse>(
    `/onboardings/${onboardId}/credit`,
    {
      method: 'GET',
    }
  );

export const saveProduct = (onboardId: string, payload: SaveProductPayload) =>
  DefaultApi.request<OnboardingCreditInfoResponse>(
    `/onboardings/${onboardId}/product/acquire`,
    {
      method: 'POST',
      data: payload,
    }
  );

export const saveBusinessRepresentative = (
  onboardId: string,
  payload: SaveRepresentativesPayload
) => {
  const formData = new FormData();

  formData.append('representatives', JSON.stringify(payload.representatives));

  if (payload.social_contract) {
    formData.append('social_contract', payload.social_contract);
  }

  return DefaultApi.request(`/onboardings/${onboardId}/representatives`, {
    method: 'POST',
    data: formData,
  });
};

export const saveRepresentatives = (
  onboardId: string,
  payload: SaveRepresentativesPayload
) =>
  DefaultApi.request<OnboardingCreditInfoResponse>(
    `/onboardings/${onboardId}/product/acquire`,
    {
      method: 'POST',
      data: payload,
    }
  );

export const updateRepresentative = (
  representativeId: string,
  payload: RepresentativeUpdatePayload
) =>
  DefaultApi.request(`/representatives/${representativeId}`, {
    method: 'PUT',
    data: payload,
  });

export const getOnboarding = async () => {
  const parsedToken = getStoredParsedToken();

  return ClosedOnboardingApi.get<ApiResponse<Onboarding>>(
    `/onboardings/${parsedToken?.onboardingId}`
  );
};

export const getStoredParsedToken = () => {
  const token = localStorage.getItem(ONBOARDING_TOKEN);
  if (!token) return null;
  return parseJWT<OnboardingToken>(token);
};

export const updateOnboardingStatus = (onboardingId: string) =>
  DefaultApi.request<OnboardingCreditInfoResponse>(
    `/onboardings/${onboardingId}/accept-credit`,
    {
      method: 'PATCH',
    }
  );
